import { reqGet, reqPost, reqPut, reqDelete } from './axiosFun';

// 分页查询机器人
export const robotPage = (params) => { return reqGet("/robot/page", params) };

// 新增机器人
export const robotInsert = (params) => { return reqPost("/robot/", params) };

// 修改机器人
export const robotUpdate = (params) => { return reqPut("/robot/", params) };

// 删除机器人
export const robotDelete = (params) => { return reqDelete("/robot/", params) };

// 查询机器人详情
export const robotDetail = (params) => { return reqGet("/robot/detail", params) };



// WEBPACK FOOTER //
// ./src/api/robot.js